export default "__VITE_ASSET__B4AP$kjj__"